"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenShareReadiness = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ReadinessCheck = _interopRequireDefault(require("../ReadinessCheck"));
var _constants = require("../../../constants");
var _ReadinessCheck2 = require("../ReadinessCheck.styled");
var _Reusable = require("../../../constants/Reusable");
var ScreenShareReadiness = exports.ScreenShareReadiness = function ScreenShareReadiness(_ref) {
  var status = _ref.status,
    onRetry = _ref.onRetry,
    onConfirm = _ref.onConfirm,
    hideBottomBorder = _ref.hideBottomBorder,
    presenterId = _ref.presenterId;
  var isPermissionDenied = [_constants.PERMISSION_DENIED, _constants.SKIPPED].includes(status);
  var failedState = status === _constants.FAILED;
  var onConfirmCallback = (0, _Reusable.useEnterUpCallback)(onConfirm);
  var FailedStatus = function FailedStatus() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "We are unable to start a screen share. Your browser might not have screen share permission on your computer. To enable, please open your system preferences and grant access."), /*#__PURE__*/_react["default"].createElement(_ReadinessCheck2.StyleP, {
      noFlex: true
    }, /*#__PURE__*/_react["default"].createElement("strong", null, "Note: you only need to do this if you want to share your entire screen.", ' '), "If you only want to share a browser tab, you can try again and select the tab when the browser prompts you."), /*#__PURE__*/_react["default"].createElement(_ReadinessCheck2.StyledP, null, /*#__PURE__*/_react["default"].createElement(_ReadinessCheck2.StyledLink, {
      "data-testId": 'screen-Share-yes',
      onClick: function onClick() {
        return onConfirm(true);
      },
      onKeyDown: onConfirmCallback,
      tabIndex: "0"
    }, "Start test"), ' '));
  };
  var PermissionDeniedStatus = function PermissionDeniedStatus() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "We were unable to test your screen share. You may still join, but we recommend testing your screen share to ensure a smooth experience."), /*#__PURE__*/_react["default"].createElement(_ReadinessCheck2.StyledP, null, /*#__PURE__*/_react["default"].createElement(_ReadinessCheck2.StyledLink, {
      onClick: onRetry,
      onKeyDown: function onKeyDown(e) {
        return (0, _Reusable.handleEnterDown)(e, onRetry);
      },
      tabIndex: "0"
    }, "Start test"), ' '));
  };
  var statusText = isPermissionDenied ? 'Screen share not tested' : failedState ? 'Permission to share entire screen not granted' : null;
  return /*#__PURE__*/_react["default"].createElement(_ReadinessCheck["default"], {
    title: "Screen share",
    status: status,
    onRetry: onRetry,
    onConfirm: onConfirm,
    statusText: statusText,
    failedText: 'Not connected or permission not granted',
    hideBottomBorder: hideBottomBorder,
    presenterId: presenterId
  }, isPermissionDenied ? /*#__PURE__*/_react["default"].createElement(PermissionDeniedStatus, null) : /*#__PURE__*/_react["default"].createElement(FailedStatus, null));
};
ScreenShareReadiness.defaultProps = {
  status: _constants.WAITING
};
ScreenShareReadiness.propTypes = {
  status: _propTypes.string.isRequired,
  onConfirm: _propTypes.func,
  onRetry: _propTypes.func,
  presenterId: _propTypes.string,
  hideBottomBorder: _propTypes.bool
};